import {restapi} from "./restapi";
import {ReturnReason} from "../models/types";

export function retrieveReturnReasons(): Promise<ReturnReason[]> {
    return restapi.get<ReturnReason[]>("/api/v1/smt_core/return_reason/?__pagination__=0").then(res => res.data);
}
